import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Sector } from '../../../models/sector.model';
import { DropdownInputComponent } from '../../utility/form/dropdown-input/dropdown-input.component';
import { UtilityService } from '../../../services/utility.service';

@Component({
  selector: 'app-sector-section-dropdown',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    DropdownInputComponent,
  ],
  templateUrl: './sector-section-dropdown.component.html',
  styleUrl: './sector-section-dropdown.component.scss',
})
export class SectorSectionDropdownComponent implements OnInit, OnChanges {
  @Output() onSectorSelect = new EventEmitter<any>();
  @Input() sectors: Sector[] = [];
  sectorForm: FormGroup;

  constructor(public utilityService: UtilityService) {}

  ngOnInit() {
    this.sectorForm = new FormGroup({
      sectors: new FormControl(this.sectors[0]?.id),
    });
  }

  ngOnChanges() {
    this.sectorForm?.get('sectors').setValue(this.sectors[0]?.id);
  }
}
